// The picture allowance in the bar's own row (`AllowanceBar.tsx`). The note lives in the spacer after the identity chip:
// two short mono lines at most, the bar's own voice, so the bar keeps its height and the picture its room.
.note {
    margin-left: auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 2px;
    text-align: right;
    font-family: var(--tl-font-label);
    font-size: 10px;
    line-height: 1.35;
    letter-spacing: 0.12em;
    text-transform: lowercase;
    color: var(--tl-dim);
    white-space: nowrap;

    > span {
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    b {
        color: var(--tl-accent);
        font-weight: 400;
    }
}

.lit {
    color: var(--tl-accent);
}

.form {
    margin: 0;
    display: flex;
    flex: none;
}

// The disabled verb: the accent dimmed, not the browser's grey. Compound with the element so it outranks the bar's
// own `.verb` whichever stylesheet loads last.
button.off {
    background: color-mix(in srgb, var(--tl-accent) 30%, transparent);
    color: color-mix(in srgb, var(--tl-accent-ink) 65%, transparent);
    box-shadow: none;
    cursor: default;
}

.label small {
    font-weight: 400;
    opacity: 0.75;
    margin-left: 6px;
}
